<template>
  <div v-if="questionsVisible">
    <SectionTitle content="Preguntas Adicionales" :has-line="true" />
    <div v-for="question in questions" :key="question.number">
      <ValidationObserver ref="questions" v-slot="{}" tag="form">
        <question
          id="qQuestions"
          :ref="'question' + question.number"
          :number="question.number"
          :sub-number="question.subNumber"
          :description="question.description"
          :answer-control-type="question.answerControlType"
          :error-message="question.errorMessage"
          :warning-message="question.warningMessage"
          :on-change="question.onChange"
          :get-default-value="question.getDefaultValue"
          :get-options="question.getOptions"
          :is-required="question.isRequired"
          :require-error-message="question.requireErrorMessage"
          :visible="question.isVisible"
          :display-number="question.displayNumber"
          :picker-min-date="question.pickerMinDate"
          :fields="question.fields"
          :field-caption="question.fieldCaption"
          :is-disabled="question.isDisabled"
          :notes="question.notes"
        />
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Question from "@/components/pei/WizardQuestion";
import { ValidationObserver } from "vee-validate";
import EduEspYesNoNA from "@/utils/constants/EduEspYesNoNA";
import generalService from "@/services/pei/general";
import store from "@/store/index";
import SectionTitle from "@/components/pei/shared/SectionTitle";

const PeiAdditionalQuestionType = Object.freeze({
  Evidencia_de_Participación_de_Alternatia_de_Ubicación: 1,
  Evidencia_de_Participación_Servicio_Transición_Post_Secundario: 2,
  Evidencia_de_que_la_Agencia_Proveyó_el_Servicio: 3,
  Fecha_de_Ubicación: 4,
  Asistente_de_Servicio: 5,
  Asistente_de_Servicio_Único: 6,
  Evidencia_movilidad_acceso: 7,
  Necesidades_expresadas: 8,
  Ajuste_organizacion_escolar: 9,
  Proveyó_ajuste: 10,
  Tipo_ajuste: 11,
  Ajuste_ambiente_integrado: 12,
  Ajuste_en_termino_5_dias: 13,
  Necesidad_Movilidad: 14
});
export default {
  name: "AddEditEgress",
  components: {
    Question,
    ValidationObserver,
    SectionTitle
  },
  props: {
    academicYear: {
      type: Object,
      required: true,
      default: null
    },
    exitid: {
      type: Number,
      required: false,
      default: 0
    }
  },
  watch: {
    academicYear(newValue) {
      generalService
        .LastPeiAdditionalQuestions(newValue.id, this.studentSie)
        .then(data => {
          this.PeiAdditionalQuestions = data.data;
          this.mapPeiAnswersToQuestions().then(() => {});
        });
    }
  },
  data() {
    return {
      PeiAdditionalQuestion: {
        PeiAdditionalQuestionId: null,
        PeiAdditionalQuestionAnswerId: null,
        AdditionalQuestionComment: null,
        AlternatePlacementId: null,
        AlternatePlacementDate: null,
        ServiceAssistantName: null,
        ServiceAssistantServiceId: null
      },
      questionsVisible: false,
      studentSie: store.getters["$_student/StudentSie"],
      PeiAdditionalQuestions: [],
      PeiAdditionalQuestionsToDB: [],
      questions: [
        {
          number: 2,
          displayNumber: "P2",
          description:
            "<p>En la Parte V del PEI <b>" +
            this.academicYear.description +
            "</b> el estudiante tiene un programa de servicios con actividades dirigidas al proceso de transición postsecundario</p>",
          answerControlType: 1,
          isVisible: true,
          onChange: this.onQuestion2Step2ValueChange,
          isRequired: true,
          requireErrorCode: "190606",
          requireErrorMessage: "Esta pregunta es requerida.",
          initialState: false
        },
        {
          number: 2.1,
          displayNumber: "P2",
          subNumber: ".1",
          description:
            "Favor de explicar las razones por la cual el estudiante no participó de las actividades dirigidas al proceso de transición postsecundario",
          answerControlType: 3,
          isVisible: false,
          isRequired: true,
          requireErrorCode: "190607",
          requireErrorMessage: "Esta pregunta es requerida.",
          initialState: false,
          fields: [
            {
              id: "comentario",
              type: "textarea",
              label: "<b>Comentario:</b>",
              name: "question-comment",
              class: "col-lg-12 col-sm-6",
              maxChars: 3000,
              value: null,
              required: true,
              requireErrorCode: "",
              requireErrorMessage: "Por favor introduzca texto"
            }
          ]
        },
        {
          number: 3,
          displayNumber: "P3",
          description:
            "En la Parte IX del PEI [Año Académico del último PEI o PS en estatus firmado] se estableció la necesidad de invitar a otras agencias para proveer algún servicio, ¿existe evidencia de que la agencia proveyó el servicio?",
          answerControlType: 1,
          isVisible: true,
          isRequired: true,
          requireErrorCode: "190608",
          requireErrorMessage: "Esta pregunta es requerida.",
          onChange: this.onQuestion3ValueChange,
          initialState: false
        },
        {
          number: 3.1,
          displayNumber: "P3",
          subNumber: ".1",
          description:
            "Especifique todas aquellas gestiones que se realizaron para que la agencia proveyera el servicio.",
          answerControlType: 3,
          isRequired: true,
          isVisible: false,
          requireErrorCode: "190609",
          requireErrorMessage: "Esta pregunta es requerida.",
          initialState: false
        }
      ]
    };
  },
  methods: {
    setQuestionVisible(questionNumber, isVisible) {
      let question = this.getQuestionElement(questionNumber);
      question.clear();
      question.isVisible = isVisible;
    },
    getQuestionElement(questionNumber) {
      return this.getQuestion(questionNumber);
    },
    onQuestion2Step2ValueChange(question) {
      if (question.selectedAnswer != undefined && question.selectedAnswer) {
        this.setQuestionVisible(2.1, false);
      } else {
        this.setQuestionVisible(2.1, true);
      }
    },
    onQuestion3ValueChange(question) {
      if (question.selectedAnswer != undefined && question.selectedAnswer) {
        this.setQuestionVisible(3.1, false);
      } else {
        this.setQuestionVisible(3.1, true);
      }
    },
    getQuestion(number) {
      let questionElement = this.$refs["question" + number];
      if (questionElement != null) {
        return questionElement[0];
      }
      return null;
    },
    validate(onlyInvalidQuestion) {
      let validationResult = true;
      if (this.questions) {
        if (onlyInvalidQuestion) {
          this.questions
            .filter(question => question.hasAnError == true)
            .forEach(question => {
              let questionElement = this.$refs["question" + question.number][0];
              let result = questionElement.validate();

              if (!result) {
                validationResult = false;
              }
            });
        } else {
          this.questions.forEach(question => {
            let questionElement = this.$refs["question" + question.number][0];

            if (questionElement != undefined) {
              let result = questionElement.validate();

              if (!result) {
                validationResult = false;
              }
            }
          });
        }
      }
      this.isValid = validationResult;

      return validationResult;
    },

    async mapPeiAnswersToQuestions() {
      let isDisabled = false;
      //Validate for question P2 and P3

      //post-secundario
      let additionalQuestions = this.PeiAdditionalQuestions;
      let questionPostSecundary = additionalQuestions.find(
        x =>
          x.peiAdditionalQuestionId ==
          PeiAdditionalQuestionType.Evidencia_de_Participación_Servicio_Transición_Post_Secundario
      );
      if (questionPostSecundary != undefined) {
        if (questionPostSecundary.peiAdditionalQuestionAnswerId) {
          isDisabled = questionPostSecundary.isReadOnly;
          this.getQuestionElement(2).selectedAnswer =
            questionPostSecundary.peiAdditionalQuestionAnswerId ==
            EduEspYesNoNA.Yes
              ? 1
              : 0;

          let question2Step2 = this.getQuestionElement(2);

          if (question2Step2.visible && question2Step2.selectedAnswer == 0) {
            await this.onQuestion2Step2ValueChange(question2Step2);
          }
          this.getQuestionElement(2).isDisabled = isDisabled;
          if (!this.getQuestionElement(2).selectedAnswer) {
            this.getQuestionElement(2.1).questionOpenAnswer =
              questionPostSecundary.additionalQuestionComment;
            this.getQuestionElement(2.1).isDisabled = isDisabled;
          }
        } else {
          this.setQuestionVisible(2, false);
          this.setQuestionVisible(2.1, false);
        }
      }

      //Evidencia agencia
      let questionAgency = additionalQuestions.find(
        x =>
          x.peiAdditionalQuestionId ==
          PeiAdditionalQuestionType.Evidencia_de_que_la_Agencia_Proveyó_el_Servicio
      );
      if (questionAgency != undefined) {
        if (questionAgency.peiAdditionalQuestionAnswerId) {
          isDisabled = questionAgency.isReadOnly;
          this.getQuestionElement(3).selectedAnswer =
            questionAgency.peiAdditionalQuestionAnswerId == EduEspYesNoNA.Yes
              ? 1
              : 0;
          await this.onQuestion3ValueChange(this.getQuestionElement(3));
          this.getQuestionElement(3).isDisabled = isDisabled;
          if (
            questionAgency.peiAdditionalQuestionAnswerId == EduEspYesNoNA.No &&
            questionAgency.additionalQuestionComment &&
            questionAgency.additionalQuestionComment.length > 0
          ) {
            this.getQuestionElement(3.1).questionOpenAnswer =
              questionAgency.additionalQuestionComment;
            this.getQuestionElement(3.1).isDisabled = isDisabled;
          } else {
            this.setQuestionVisible(3.1, false);
          }
        } else {
          this.setQuestionVisible(3, false);
          this.setQuestionVisible(3.1, false);
        }
      }
    },

    async mapQuestionsAnswers() {
      this.PeiAdditionalQuestionsToDB = [];

      //paso preguntas adicionales---------------------------------------------------------------------------------------------------

      //post-secundario
      let question2 = this.getQuestionElement(2);
      this.PeiAdditionalQuestion = {};
      let paPostSecundario = this.PeiAdditionalQuestion;
      paPostSecundario.PeiAdditionalQuestionId =
        PeiAdditionalQuestionType.Evidencia_de_Participación_Servicio_Transición_Post_Secundario;
      paPostSecundario.PeiAdditionalQuestionAnswerId = question2.selectedAnswer
        ? EduEspYesNoNA.Yes
        : EduEspYesNoNA.No;

      if (!question2.selectedAnswer) {
        paPostSecundario.AdditionalQuestionComment = this.getQuestionElement(
          2.1
        ).questionOpenAnswer;
      }

      if (question2.selectedAnswer != null) {
        this.PeiAdditionalQuestionsToDB.push(paPostSecundario);
      }

      //agencia
      let question3 = this.getQuestionElement(3);
      this.PeiAdditionalQuestion = {};
      let paAgencyParticipation = this.PeiAdditionalQuestion;
      paAgencyParticipation.PeiAdditionalQuestionId =
        PeiAdditionalQuestionType.Evidencia_de_que_la_Agencia_Proveyó_el_Servicio;
      paAgencyParticipation.PeiAdditionalQuestionAnswerId = question3.selectedAnswer
        ? EduEspYesNoNA.Yes
        : EduEspYesNoNA.No;

      if (!question3.selectedAnswer) {
        paAgencyParticipation.AdditionalQuestionComment = this.getQuestionElement(
          3.1
        ).questionOpenAnswer;
      }

      if (question3.selectedAnswer != null) {
        this.PeiAdditionalQuestionsToDB.push(paAgencyParticipation);
      }
    },
    //////
    async hasAgencyLastYearSignedPei() {
      await this.GetLatestSignedPEI(this.academicYear.year - 1).then(result => {
        if (result.data) {
          this.questionsVisible =
            result.data.hasParticipantsAgencies ||
            result.data.configTransitionServicesFlag == "1";

          if (this.questionsVisible) {
            //pregunta 2
            this.getQuestionElement(2).text =
              "<p> En la Parte V del PEI <b>" +
              (this.academicYear.year - 2) +
              "-" +
              (this.academicYear.year - 1) +
              "</b> el estudiante tiene un programa de servicios" +
              " con actividades dirigidas al proceso de transición postsecundario </p>";

            this.setQuestionVisible(
              2,
              result.data.configTransitionServicesFlag == "1"
            );
            //pregunta 3
            this.getQuestionElement(3).text =
              "En la Parte IX del PEI <b>" +
              (this.academicYear.year - 2) +
              "-" +
              (this.academicYear.year - 1) +
              "</b> se estableció la necesidad de invitar a otras agencias para proveer algún servicio, ¿existe evidencia de que la agencia proveyó el servicio?";
            this.setQuestionVisible(3, result.data.hasParticipantsAgencies);
          }
        }
      });
    },
    GetLatestSignedPEI(academyYear) {
      return new Promise((resolve, reject) => {
        this.$ApiGet(
          "/api/pei/getlatestsignedpeips?studentSieId=" +
            this.studentsie +
            "&academicYear=" +
            academyYear
        ).then(
          response => resolve(response),
          error => reject(error)
        );
      });
    }
    /////////
  },
  computed: {
    isValid() {
      if (this.questionsVisible) {
        return this.validate(false);
      } else {
        return true;
      }
    },
    studentAge() {
      return this.$store.getters["$_student/getMipeStudent"].age;
    },
    studentsie() {
      return store.getters["$_student/StudentSie"];
    }
  },
  async mounted() {
    await this.hasAgencyLastYearSignedPei();

    if (this.questionsVisible) {
      var questions = (
        await generalService.LastPeiAdditionalQuestions(this.exitid)
      ).data;

      if (questions.length > 0) {
        this.PeiAdditionalQuestions = questions;
        await this.mapPeiAnswersToQuestions();
      } else {
        await this.mapQuestionsAnswers();
      }
    }
  }
};
</script>
